export default "__VITE_ASSET__pMquLGSI__"